import { AdmAPIList } from '@/api'

const api = new AdmAPIList();

export default {

  createAgent({ state }, param) {
    return new Promise((resolve, reject) => {
      api.createAgent(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  createProduct({ state }, param) {
    return new Promise((resolve, reject) => {
      api.createProduct(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  editAgent({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editAgent(param,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  editProduct({ state }, param) {
    return new Promise((resolve, reject) => {
      api.editProduct(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },


  getAgentList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAgentList(param,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getProductList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getProductList(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },


  getAgentDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAgentDetail(param,
        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getProductDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getProductDetail(param,

        (json) => {
          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })

  },

  getBulletinList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinList(param,
        (json) => {

          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },

  getAuditTrailFunctionList({ state }) {
    return new Promise((resolve, reject) => {
      api.getAuditTrailFunctionList((json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getAuditTrailList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getAuditTrailList(param,
        (json) => {
          resolve(json);
        }, (err) => {
          reject(err);
        })
    })
  },

  createBulletin({ state, commit }, param) {
    return new Promise((resolve, reject) => {
      api.createBulletin(param, (json) => {

        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  getBulletinDetail({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getBulletinDetail(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },


  editBulletin({ state, commit }, param) {
    return new Promise((resolve, reject) => {
      api.editBulletin(param, (json) => {
        resolve(json.data);
      }, (err) => {
        reject(err);
      });
    });
  },

  deleteBulletin({ state, commit }, params) {
    return new Promise((resolve, reject) => {
      api.deleteBulletin(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getDocumentList({ state }, param) {
    return new Promise((resolve, reject) => {
      api.getDocumentList(param,
        (json) => {

          resolve(json);
        },
        (err) => {
          reject(err);
        })
    })
  },


  getTeamList({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getTeamList(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  createTeam({ state }, params) {
    return new Promise((resolve, reject) => {
      api.createTeam(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  editTeam({ state }, params) {
    return new Promise((resolve, reject) => {
      api.editTeam(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  assignAgent({ state }, params) {
    return new Promise((resolve, reject) => {
      api.assignAgent(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  resignAgent({ state }, params) {
    return new Promise((resolve, reject) => {
      api.resignAgent(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getTeamDetail({ state }, ID) {
    var params = { ID: ID };
    return new Promise((resolve, rejcet) => {
      api.getTeamDetail(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getCompanyCommRecord({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCompanyCommRecord(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  payCompanyCommission({ state }, params) {
    return new Promise((resolve, reject) => {
      api.payCompanyCommission(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getCommissionRecord({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getCommissionRecord(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  payCommission({ state }, params) {
    return new Promise((resolve, reject) => {
      api.payCommission(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  },

  getProviderOptions({ state }, params) {
    return new Promise((resolve, reject) => {
      api.getProviderOptions(params, (json) => {
        resolve(json);
      }, (err) => {
        reject(err);
      })
    })
  }


}



// WEBPACK FOOTER //
// ./src/Adm/store/actions.js